// Status devolvidos pela API no campo `status` do tratamento.
export const APPROVED_STATUS = 'Aprovado';
export const FINISHED_STATUS = 'Finalizado';
export const REFUSED_STATUS = 'Recusado';

export const isApproved = (treatment) => treatment?.status === APPROVED_STATUS;
export const isRefused = (treatment) => treatment?.status === REFUSED_STATUS;
export const isFinished = (treatment) => treatment?.status === FINISHED_STATUS;

export const statusChipColor = (status) => {
  if (status === APPROVED_STATUS) return 'success';
  if (status === FINISHED_STATUS) return 'primary';
  if (status === REFUSED_STATUS) return 'default';
  return 'info';
};
